import type { RegistrationAccessStatus } from '../lib/registerApi';
import type { User } from '../types';

export type RegistrationAccessResult = { userId: string; status: RegistrationAccessStatus | null; error?: boolean };

export function registrationWaitingState(user: User | null, result: RegistrationAccessResult | null): 'workspace' | 'waiting' | 'checking' | 'error' {
  if (!user || user.club_id) return 'workspace';
  const ownResult = result?.userId === user.id ? result : null;
  if (ownResult?.status?.pending) return 'waiting';
  if (user.role !== 'user') return 'workspace';
  if (!ownResult?.status) return ownResult?.error ? 'error' : 'checking';
  return 'workspace';
}
